import {
  LayoutDashboard,
  Users,
  ShieldCheck,
  HeartHandshake,
  MailCheck,
  CalendarHeart,
  UserCheck,
  Building2,
  Crown,
  CreditCard,
  Headphones,
  Bell,
  FileCode2,
  Tags,
  Settings,
  ShieldAlert,
  Terminal,
  Gift,
} from 'lucide-react';

export const SIDEBAR_SECTIONS = [
  {
    title: 'Overview',
    items: [
      { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
    ],
  },
  {
    title: 'Community',
    items: [
      { id: 'users', label: 'Users', path: '/users', icon: Users },
      { id: 'verification', label: 'Verification', path: '/verification', icon: ShieldCheck, badgeColor: 'orange' },
      { id: 'events', label: 'Events', path: '/events', icon: CalendarHeart },
      { id: 'venues', label: 'Venues', path: '/venues', icon: Building2 },
      { id: 'participants', label: 'Participants', path: '/participants', icon: UserCheck },
      { id: 'categories', label: 'Categories', path: '/categories', icon: Tags },
      { id: 'invitations', label: 'Invitations', path: '/invitations', icon: MailCheck },
    ],
  },
  {
    title: 'Monetization',
    items: [
      { id: 'subscriptions', label: 'Subscriptions', path: '/subscriptions', icon: Crown },
      { id: 'special-offers', label: 'Special Offers', path: '/special-offers', icon: Gift, badgeColor: 'pink' },
      { id: 'payments', label: 'Payments', path: '/payments', icon: CreditCard },
    ],
  },
  {
    title: 'Platform & System',
    items: [
      { id: 'support-tickets', label: 'Support Tickets', path: '/support-tickets', icon: Headphones, badgeColor: 'red' },
      { id: 'notifications', label: 'Notifications', path: '/notifications', icon: Bell },
      { id: 'cms', label: 'CMS', path: '/cms', icon: FileCode2 },
      { id: 'settings', label: 'Settings', path: '/settings', icon: Settings },
      { id: 'roles-permissions', label: 'User & Role Management', path: '/roles-permissions', icon: ShieldAlert },
      { id: 'system-logs', label: 'System Logs', path: '/system-logs', icon: Terminal },
    ],
  },
];

export const SIDEBAR_MENU = SIDEBAR_SECTIONS.flatMap((section) => section.items);

